<template>
  <div class="row">
    <div class="col-12">
      <div class="c-sorting">
        <div class="row">
          <div class="col-lg-12 c-sorting__right">
            <h3 class="float-left">{{ $t('clientList') }}</h3>
            <div class="c-sorting__btn">
              <export v-show="filterFormModel.keyword" :filter="filterFormModel"
                      :total-count="itemCount"></export>
            </div>
          </div>
        </div>
      </div>
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount && filterFormModel.keyword">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize && filterFormModel.keyword" class="pull-right"
                          size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize"
                          @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length && filterFormModel.keyword">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-3">{{ $t('companyName') }}</div>
          <div class="col-2">{{ $t('phone') }}</div>
          <div class="col-2">{{ $t('email') }}</div>
          <div class="col-3">Domain</div>
          <div class="col-2">{{ $t('registrationTime') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-3">
            <p v-if="item.companyName">{{ item.companyName }}</p>
          </div>
          <div class="col-2">
            <p v-if="item.phone">{{ item.phone }}</p>
          </div>
          <div class="col-2">
            <p v-if="item.email">{{ item.email }}</p>
          </div>
          <div class="col-3">
            <p v-if="item.domain">{{ item.domain }}</p>
          </div>
          <div class="col-2">
            <p v-if="item.createTime">{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!filterFormModel.keyword">
      <span>{{ $t('enterNumberNote') }}</span>
    </div>
    <div class="col-12 text-center text-danger" v-else-if="!items.length">
      <span>{{ $t('notFoundSearch') }}</span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import List from '../../mixins/List';
import Export from './ClientExport.vue';

export default {
  props: ['filter'],
  components: {Export},
  mixins: [List],
  data() {
    return {
      service: '/lookup-customer/client',
      autoLoad: false,
      defaultFilterFormModel: {
        page: 1,
        pageSize: 10,
      }
    }
  },
  methods: {
    load: _.debounce(function () {
      this.filterFormModel.keyword = this.filter.keyword;
      if (this.filterFormModel.keyword) {
        let loader = this.$loading.show();
        this.$service.get(this.service, {
          params: this.filterFormModel
        }).then(response => {
          this.apply(response.data);
        }).catch(error => {
          if (error.response.data.message) {
            this.$swal({
              text: error.response.data.message,
              icon: 'error'
            });
          }
        }).finally(() => {
          loader.hide();
        });
      }
    }, 200, {leading: true, trailing: false}),
  },
  mounted() {
    this.filterFormModel = Object.assign({}, this.filter, this.defaultFilterFormModel);
  },
  i18n: {
    messages: {
      en: {
        phone: 'Phone number',
        notFoundSearch: 'No result found! Change your search condition and try again!',
        enterNumberNote: "Please enter customer phone number!",
        customerLookup: "Look up customers",
        enterNumber: "Enter phone number",
        registrationTime: "Registration time",
        clientList: "List of clients",
      },
      vi: {
        phone: 'Số điện thoại',
        notFoundSearch: 'Không tìm thấy kết quả nào! Hãy thay đổi điều kiện tìm kiếm và thử lại!',
        enterNumberNote: "Xin hãy nhập số điện thoại khách hàng!",
        customerLookup: "Tra cứu khách hàng",
        enterNumber: "Nhập số điện thoại",
        registrationTime: "Thời gian đăng ký",
        clientList: "Danh sách client",
      }
    }
  }
}
</script>